export default __webpack_public_path__ + "locales/fr/PeopleTranslations.json?hash=6bc5f6981400e2515e9b77a53c634643";